import React from 'react';

import { Paper, useMediaQuery } from '@mui/material';
import { Theme, useTheme } from '@mui/material/styles';
import { ClientSafeTenantConfig } from 'server/config-cache/types';
import ConfigContext from 'src/context/config';
import useNonNullContext from 'src/hooks/useNonNullContext';

import DesktopFooter from './DesktopFooter';
import MobileFooter from './MobileFooter';

export type FooterSubcomponentProps = ClientSafeTenantConfig['footer'] & {
  textColor: string;
  accentTextColor: string;
  isShowingCart: boolean;
};
interface FooterProps {
  /**
   * All this really does is add some bottom margin to the footer so that the content isn't covered up by the sticky
   * footer that is shown when editing a cart.
   */
  isShowingCart: boolean;
}

const Footer: React.FC<FooterProps> = ({ isShowingCart }) => {
  const configContext = useNonNullContext(ConfigContext);

  const theme = useTheme();

  const isSmallScreen = useMediaQuery<Theme>((theme) =>
    theme.breakpoints.down('md'),
  );

  // colors defined here and passed to footer subcomponents to ensure uniformity
  const backgroundColor = theme.palette.grey[900];
  const textColor = theme.palette.grey[300];
  const accentTextColor = theme.palette.common.white;

  return (
    <Paper
      sx={{
        backgroundColor,
        color: textColor,
      }}
      square
    >
      {isSmallScreen ? (
        <MobileFooter
          {...configContext.footer}
          textColor={textColor}
          accentTextColor={accentTextColor}
          isShowingCart={isShowingCart}
        />
      ) : (
        <DesktopFooter
          {...configContext.footer}
          textColor={textColor}
          accentTextColor={accentTextColor}
          isShowingCart={isShowingCart}
        />
      )}
    </Paper>
  );
};

export default Footer;
